import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ReceiptIcon = (props: IconProps) => (
  <Icon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    title={t`Receipt`}
    {...props}
  >
    <Path
      d="M2.66699 1.33331V14.6666L4.00033 14L5.33366 14.6666L6.66699 14L8.00033 14.6666L9.33366 14L10.667 14.6666L12.0003 14L13.3337 14.6666V1.33331L12.0003 1.99998L10.667 1.33331L9.33366 1.99998L8.00033 1.33331L6.66699 1.99998L5.33366 1.33331L4.00033 1.99998L2.66699 1.33331Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M10.6663 5.33331H6.66634C6.31272 5.33331 5.97358 5.47379 5.72353 5.72384C5.47348 5.97389 5.33301 6.31302 5.33301 6.66665C5.33301 7.02027 5.47348 7.35941 5.72353 7.60946C5.97358 7.8595 6.31272 7.99998 6.66634 7.99998H9.33301C9.68663 7.99998 10.0258 8.14046 10.2758 8.3905C10.5259 8.64055 10.6663 8.97969 10.6663 9.33331C10.6663 9.68694 10.5259 10.0261 10.2758 10.2761C10.0258 10.5262 9.68663 10.6666 9.33301 10.6666H5.33301"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8 11.6666V4.33331"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </Icon>
);
